import classNames from 'classnames/bind';
import styles from './ForgotPasswordForm.module.scss';
import { AppBar, Box, InputLabel, TextField, Typography } from '@mui/material';
import { images } from '~/assets';
import { Button } from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { adminRouteAbsolute } from '~/utils/constants/route';
import { useAppDispatch } from '~/redux/hooks';
import { IForgotPassword } from '~/utils/interface/auth';
import { useFormik } from 'formik';
import { handleForgotPassword } from '~/thunks/auth/authThunk';
import { handleApiError, notify } from '~/utils/helper';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);

type Props = {};

const initialValues: IForgotPassword = {
  email: '',
};

const ForgotPassword = (props: Props) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['admin/common']);
  const navigate = useNavigate();

  const form = useFormik({
    initialValues,
    onSubmit: async (values, { setFieldError }) => {
      try {
        await dispatch(handleForgotPassword({ params: values })).unwrap();
        notify('success', t('submitResetEmail', { ns: 'admin/common' }));
        navigate(`${adminRouteAbsolute.login}`);
      } catch (e) {
        handleApiError(e, setFieldError);
      }
    },
  });

  const redirectSignUp = () => {
    navigate(`${adminRouteAbsolute.signUp}`);
  };

  const redirectLogin = () => {
    navigate(`${adminRouteAbsolute.login}`);
  };

  return (
    <Box className={cx('w-full', 'h-full')}>
      <AppBar
        color='inherit'
        className={cx('px-4 md:px-20 py-2.5 border-b border-[#E5EAEF]')}
        elevation={0}
        position='relative'
      >
        <Box className={cx('flex justify-between items-center')}>
          <img src={images.logo} alt='' className={cx('w-[61px] h-[62px]')} />
          <Box className={cx('h-9')}>
            <Button
              className={cx(
                'h-9 w-16 inline-block !font-medium !rounded-lg !leading-[16.8px] !text-[#3A3F51] !mr-3 !px-[14px] !py-[7px]'
              )}
              onClick={redirectLogin}
            >
              Login
            </Button>
            <Button
              variant='contained'
              color='primary'
              className={cx('!rounded-lg !leading-[16.8px] h-9 w-[76px] !px-[14px] !py-[7px]')}
              onClick={redirectSignUp}
            >
              Sign up
            </Button>
          </Box>
        </Box>
      </AppBar>
      <Box component='section' className={cx('w-full h-full flex justify-center items-center fixed z-20')}>
        <Box component='form' onSubmit={form.handleSubmit} className={cx('max-w-[500px] w-full px-4 sm:px-0')}>
          <Box>
            <Box className={cx('text-center gap-5')}>
              <img src={images.logo} alt='' className={cx('w-[60px] h-[60px] inline-block')} />
              <Box className={cx('mt-5')}>
                <Typography className={cx('!font-medium !text-black !text-4xl !leading-[43.2px]')} variant='h2'>
                  Reset Your Password
                </Typography>
                <Typography
                  variant='body1'
                  className={cx('!font-normal !text-base !leading-[19.2px] !text-[#86929D] !mt-2.5')}
                >
                  We will send you instructions how to reset your password by email.
                </Typography>
              </Box>
            </Box>
            <Box className={cx('sm:mt-[60px] mt-6')}>
              <Box>
                <InputLabel className={cx('!text-[12px] text-[#323953] !font-normal !leading-[14.4px]')}>
                  Email
                </InputLabel>
                <TextField
                  className='w-full'
                  name='email'
                  placeholder='Enter your email'
                  value={form.values.email}
                  onChange={form.handleChange}
                  error={Boolean(form.errors.email)}
                  helperText={form.errors.email}
                />
              </Box>
            </Box>
          </Box>
          <Box className={cx('mt-[30px]')}>
            <Button
              type='submit'
              variant='contained'
              color='primary'
              sx={{
                boxShadow: 'none',
                '&:hover': {
                  boxShadow: 'none',
                },
              }}
              className={'w-full !rounded-lg h-9 leading-[16.8px]'}
            >
              Send
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        className={cx(
          'w-full',
          'h-[40%]',
          'background-bottom',
          'fixed',
          'bottom-0',
          'bg-cover',
          'bg-center',
          'opacity-[0.02]'
        )}
      ></Box>
    </Box>
  );
};

export default ForgotPassword;
